
import './App.css';
import Greatest from './components/Greatest/Greatest';
import Header from './components/Header/Header';

function App() {
  return (
    <div className="App">
      <Header></Header>
      <Greatest></Greatest>

    </div>
  );
}

export default App;
